<template>
    <div>
        <div v-if="leadTitle" class="mb-5 align-items-center gadget-claim-lead-article">
            <div class="col-sm-6">
                <h1 class="display-4 mt-3">{{leadTitle}}</h1>
                <p class="lead">{{leadText}}</p>
            </div>
            <div class="col-sm-6 lead-image-container">
                <img v-if="leadImageExt == 'jpg'" :src="require(`../assets/theme/${getReseller.id}/images/${leadImage}.jpg`)" class="gadget-claim-main-image"/>
                <img v-if="leadImageExt == 'png'" :src="require(`../assets/theme/${getReseller.id}/images/${leadImage}.png`)" class="gadget-claim-main-image"/>
            </div>
        </div>
        <div v-if="leadTitleItem && leadTitleItem.value" class="lead-article-container">            
            <div class="lead-article">
                <h1 :class="leadTitleItem.sectionClass">{{leadTitleItem.value}}</h1>
                <p class="lead">{{leadText}}</p>
            </div>
            <div class="svg-container"></div>
        </div>
    </div>    
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    methods: {
        // leadContent(url) {
            
        //     var urlPair = {
        //         '/home' : { title: 'Gadget claims', text: 'You can make a claim and check on the progress of an existing claim by choosing from the options below.', titleClass: '', textClass: 'lead' },
        //         '/makeaclaim/1' : { title: 'Make a claim', text: 'make a claim page', titleClass: '', textClass: 'lead' },
        //         '/makeaclaim/2' : { title: 'Your details', text: '', titleClass: 'middle-title', textClass: 'lead' }
        //     }
        //     var url = this.$route.path;
        //     console.log(urlPair[url])
        //     // return urlPair[url.split('/')[1]];
        //     return urlPair[url];
        // }
    },
    computed: {
        ...mapGetters({      
            getReseller: 'reseller/getResellerInfo'
        }),
        leadImageExt() {
        if (this.getReseller.leadImageExt)
            return this.getReseller.leadImageExt
        else
            return `jpg`
        },
        leadImage () {
        if (this.getReseller.leadImage)
            return this.getReseller.leadImage
        else
            return 'gadgets'
        },        
        leadConfig() {
            return this.leadContent(this.$route.path);
        },
        leadTitle() {
            return this.$textManager.getText("leadTitle", this.$route.name)
        },
        leadTitleItem() {
            const textItem = this.$textManager.getTextItem("leadTitle", this.$route.name)
            if (textItem) {
                return textItem;
            } else {
                return this.$textManager.getEmpty();    
            }
        },
        leadText() {
            return this.$textManager.getText("leadText", this.$route.name)
        }
    }    
}

</script>

<styles scoped lang="scss">
.middle-title {
    margin: auto 0;
}
</styles>